import { Component } from '@verndale/core';
class MobileDropdown extends Component {
  constructor(el) {
    super(el);
  }
  setupDefaults() {
    this.dom = {
      $header: this.$el.find('.js-mobile-dropdown__header'),
      $optionsPanel: this.$el.find('ul'),
      $options: this.$el.find('li'),
      $chevron: this.$el.find('.chevron')
    };
  }
  addListeners() {
    this.dom.$header.on('click', ::this.onDropdownClick);
    this.dom.$options.on('click', ::this.onOptionClick);
  }
  onDropdownClick(e) {
    e.stopPropagation();
    e.preventDefault();
    this.toggleDropdown();
  }

  toggleDropdown() {
    if (this.dom.$header.hasClass('js-mobile-dropdown--is-open')) {
      this.closeDropDown();
    } else {
      this.openDropDown();
    }
  }

  openDropDown() {
    this.dom.$header.addClass('js-mobile-dropdown--is-open');
    this.dom.$chevron.removeClass('bottom').addClass('top');
    this.dom.$optionsPanel.slideDown('fast');
  }

  closeDropDown() {
    this.dom.$header.removeClass('js-mobile-dropdown--is-open');
    this.dom.$chevron.removeClass('top').addClass('bottom');
    this.dom.$optionsPanel.slideUp('fast');
  }

  onOptionClick(e) {
    this.updateDropdown($(e.currentTarget));
  }

  updateDropdown($option) {
    this.closeDropDown();
    const activeText = $option.text();
    this.dom.$options.removeClass('is-active');
    $option.addClass('is-active');
    this.dom.$header.find('.js-mobile-dropdown__active-label').text(activeText);
  }
}
export default MobileDropdown;
